import partialRight from 'lodash.partialright';
import { connect } from 'react-redux';
import {
    FETCH_KEYWORDS,
    FETCH_GEO_REGIONS,
} from '@finn-no/redux-career/actions/types';
import * as actions from '@finn-no/redux-career/actions';
import { FourSteps } from '@finn-no/career-preferences-prompt';
import analytics, {
    CAREER_FUNNEL_STEP,
    CAREER_FUNNEL_EXIT,
} from '../analytics-actions';

const ctx = { location: 'ad' };

export default connect(
    state => ({
        keywords: state.keywords,
        keywordPreferences: state.keywordPreferences,
        geoRegions: state.geoRegions,
        geoRegionPreferences: state.geoRegionPreferences,
        notificationOptions: state.notificationOptions,
    }),
    {
        mockFetchKeywords: () => ({ type: FETCH_KEYWORDS }),
        fetchKeywords: partialRight(actions.keywords.fetch, ctx),
        changeKeywordQuery: partialRight(actions.keywords.changeQuery, ctx),
        fetchKeywordPreferences: partialRight(
            actions.keywordPreferences.fetch,
            ctx
        ),
        addKeywordPreference: partialRight(actions.keywordPreferences.add, ctx),
        removeKeywordPreference: partialRight(
            actions.keywordPreferences.remove,
            ctx
        ),
        mockFetchGeoRegions: () => ({ type: FETCH_GEO_REGIONS }),
        fetchGeoRegions: partialRight(actions.geoRegions.fetch, ctx),
        changeGeoRegionQuery: partialRight(actions.geoRegions.changeQuery, ctx),
        fetchGeoRegionPreferences: partialRight(
            actions.geoRegionPreferences.fetch,
            ctx
        ),
        addGeoRegionPreference: partialRight(
            actions.geoRegionPreferences.add,
            ctx
        ),
        removeGeoRegionPreference: partialRight(
            actions.geoRegionPreferences.remove,
            ctx
        ),
        fetchNotificationOptions: partialRight(
            actions.notificationOptions.fetch,
            ctx
        ),
        saveNotificationOption: partialRight(
            actions.notificationOptions.save,
            ctx
        ),
        trackStep: step => analytics(CAREER_FUNNEL_STEP, { step }),
        trackExit: step => analytics(CAREER_FUNNEL_EXIT, { step }),
    }
)(FourSteps);



// WEBPACK FOOTER //
// ./containers/CareerPreferencesAd.js